/* eslint-disable */
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { modalActions } from '@/Actions';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import wastageAnalyticsServices from '@/Services/Analytics Services/wastage-analytics.services';
import { ListTable } from '@/Components/ListTable';
import { AddWastageReasonModal } from '@/Components/Modals/AddWastageReasonModal';
import { Button } from '@mui/material';
import { useAuth } from '@/Components/Auth/Login/auth';

const FIND_FILTERS = [];

const COLMAP = {
	ID: 'id',
	'Store Name': 'storeName',
	'Store Type': 'storeType',
	'Store Sub Type': 'storeSubType',
	'Wastage Reason': 'reason',
};

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store Sub Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Wastage Reason',
		config: {
			type: 'DATA',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'Delete',
		config: {
			type: 'delete',
		},
	},
];

const WastageReasons = (props) => {
	const { toggleAddWastageReasonModal } = props;
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};


	const [wastageReasonsList, setWastageReasonsList] = useState([]);

	const handleAddClick = () => {
		toggleAddWastageReasonModal(true, {
			onSuccessCallback: () => {
				handleListFetch();
			},
		});
	};

	const handleListFetch = async (filters) => {
		try {
			const response =
				await wastageAnalyticsServices.fetchWastageReasonsList({
					req: {
						params: {
							storeId: filters?.store?.id,
						},
					},
				});
			if (response?.statusCode === 200) {
				setWastageReasonsList(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		}
	};

	const handleDelete = async (reason) => {
		try {
			const response = await wastageAnalyticsServices.deleteWastageReason(
				{
					req: {
						params: {
							reasonId: reason?.id,
						},
					},
				}
			);
			if (response?.statusCode === 200) {
				handleListFetch();
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		}
	};

	useEffect(() => {
		handleListFetch();
	}, []);

	return (
		<div>
			<AddWastageReasonModal />
			<div className='p-2'>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Wastage Reasons</span>
				{level !== 1 && (
					<Button
						onClick={handleAddClick}
						className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
					>
						+ Add Reason
					</Button>
				)}
			</div>
			</div>
			<ListTable
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={wastageReasonsList}
				actions={level !== 1 ? [...ACTION_COLUMNS] : []}
				special={{}}
				handleDelete={handleDelete}
			/>
		</div>
	);
};

const mapStateToProps = () => {};
const mapDispatchToProps = {
	toggleAddWastageReasonModal: modalActions.toggleAddWastageReasonModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(WastageReasons);
